import {Profile} from '../../models';

export const profiles: Profile[] = [
  {
    id: 1,
    email: '0123456789',
    role: 'HR',
    name: 'HR Staff 1',
    createdAt: '2021-09-13T10:33:13.901Z',
    updatedAt: '2021-09-13T10:33:13.901Z',
  },
  {
    id: 2,
    email: '0123456788',
    role: 'HR',
    name: 'HR Staff 2',
    createdAt: '2021-09-13T10:33:13.901Z',
    updatedAt: '2021-09-13T10:33:13.901Z',
  },
];
